import { Component, OnInit, Input, EventEmitter, Output, HostListener } from '@angular/core';
import { Observable, timer, Subscription } from 'rxjs';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';



@Component({
  selector: 'app-historical-view',
  templateUrl: './historical-view.component.html',
  styleUrls: ['./historical-view.component.css']
})
export class HistoricalViewComponent implements OnInit {



	@HostListener('window:beforeunload', [ '$event' ])
	beforeUnloadHander(event) {
		if (!this.isTeacher) {}
		this.db.list('/Session-'+this.service.sessionId + "/disconnected").push("1");
	}


	@Input() isTeacher: boolean;
	@Output() exitHistorical = new EventEmitter();

	actionSub: Subscription;


	data = [
		['JA', 0],
		['NEJ', 0]
	];
	data2 = [
	   ['JA', 0],
	   ['NEJ', 0]
	];
	data3 = [
	   ['JA', 0],
	   ['NEJ', 0]
	];

type ='PieChart';
options = {
	id: "chart1",
	colors: ['#6CAEDF', '#4FB847'],
	height: 400,
	backgroundColor: "transparent",
	legend: 'none',
	pieSliceText: 'label',
	tooltip: {textStyle:  {fontSize: 14,bold: true}}
};
options2 = {
	id: "chart2",
	colors: ['#6CAEDF', '#7372A9'],
 	height: 400,
	backgroundColor: "transparent",
	legend: 'none',
	pieSliceText: 'label',
	tooltip: {textStyle:  {fontSize: 14,bold: true}}
};
options3 = {
	id: "chart3",
	colors: ['#EF4E91', '#F78F1E'],
	height: 400,
	backgroundColor: "transparent",
	legend: 'none',
	pieSliceText: 'label',
	tooltip: {textStyle:  {fontSize: 14,bold: true}}
};


	question_positive_1 = 0;
	question_positive_2 = 0;
	question_positive_3 = 0;

	question_negative_1 = 0;
	question_negative_2 = 0;
	question_negative_3 = 0;

	myAnswers = [];



	users = 0;
	caseView = false;
	showSources = false;
	track = 0;
	case = 1;
	texts : any;
	quizQuestions: any;
	currentTitle = "";
	currentText = "";
	currentSource = "";
	currentImageText = "";
	sourceArrow = "keyboard_arrow_down";

	constructor(
		private service: ApiCallerService,
		private db: AngularFireDatabase) { }


	  ngOnDestroy() {
	  	if (!this.isTeacher)
	    	this.actionSub.unsubscribe();
	  }

	ngOnInit() {

		// this.service.sessionId = "342216";
		// this.service.selectedTrack = 1;

		this.myAnswers = this.service.myAnswers

		if (!this.isTeacher) {
			this.actionSub = this.db.list('/Session-'+this.service.sessionId + "/action").valueChanges().subscribe((action: any) => {
				if (action.length == 0) {
				  return;
				}

				if (action == "text"){
					this.service.currentQuestion = 3;
					this.exitHistorical.emit(1);
				}
				else if (action == "previous"){
					this.service.currentQuestion = 4;
				    this.exitHistorical.emit(0);
				}
			});

		}



		this.track = this.service.selectedTrack;
		this.quizQuestions = this.service.quizQuestions[this.service.selectedTrack];

		if (this.service.selectedTrack == 1) {
			this.texts = this.service.historical_1;
		}
		else if (this.service.selectedTrack == 2) {
			this.texts = this.service.historical_2;
		}
		else {
			this.texts = this.service.historical_3;
		}
		
		// Hämta alla svaren från frågorna
		this.db.list('/Session-'+ this.service.sessionId+"/answer").valueChanges().subscribe((answers: any) => {
			// this.test = answers;
			for(var i of answers)
			{
				if (i.question == 1 && i.track == this.service.selectedTrack) {
					if (i.answer == "ja")
						this.question_positive_1++;
					else
						this.question_negative_1++;
				}
				if (i.question == 2 && i.track == this.service.selectedTrack) {
					if (i.answer == "ja")
						this.question_positive_2++;
					else
						this.question_negative_2++;
				}
				if (i.question == 3 && i.track == this.service.selectedTrack) {
					if (i.answer == "ja")
						this.question_positive_3++;
					else
						this.question_negative_3++;
				}
				
			}

		this.data = [
			['JA', this.question_positive_1],
			['NEJ', this.question_negative_1]
		];
		this.data2 = [
			['JA', this.question_positive_2],
			['NEJ', this.question_negative_2]
		];
		this.data3 = [
			['JA', this.question_positive_3],
			['NEJ', this.question_negative_3]
		];

		});

		// console.log(this.data[0] = 5);
		console.log(this.data);
		// this.db.list('/Session-'+ this.service.sessionId+'/answer').valueChanges().subscribe((answers: any) => {
		// 	console.log( answers );
		// 	for(let row of answers){
		// 		// console.log(row.answer);
		// 		if (row.question == 1) {
		// 			console.log(row.answer)
		// 		}
		// 	}
		// });


	}


	goBack(){
		this.caseView = false;
	}

	openCase(event){

		window.scroll(0,0);
		if (event == 1) {
			this.currentTitle = this.texts.part1.title;
			this.currentText = this.texts.part1.text;
			this.currentSource = this.texts.part1.source;
			this.currentImageText = this.texts.part1.imagetext;	
		}
		else if(event == 2){
			this.currentTitle = this.texts.part2.title;
			this.currentText = this.texts.part2.text;
			this.currentSource = this.texts.part2.source;
			this.currentImageText = this.texts.part2.imagetext;	
		}
		else{
			this.currentTitle = this.texts.part3.title;
			this.currentText = this.texts.part3.text;
			this.currentSource = this.texts.part3.source;
			this.currentImageText = this.texts.part3.imagetext;	
		}

		this.caseView = true;
		this.case = event;
		
	}
	exitCases(){
		window.scroll(0,0);
		this.exitHistorical.emit(1);
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("text");
	}

	previousQuestion(){
		this.exitHistorical.emit(0);
		this.service.currentQuestion = 3;
		this.db.list('/Session-'+this.service.sessionId + "/question").remove();
		this.db.list('/Session-'+this.service.sessionId + "/question").push("3");

		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("previous");
	}

	showSourcesFunc(){
		if (this.showSources){
			this.showSources = false;
			this.sourceArrow = "keyboard_arrow_down"
		}
		else	{
			this.showSources = true;
			this.sourceArrow = "keyboard_arrow_up"
		}
	}

}
